import React from 'react';
import { FormField } from '../../../types/formBuilder';

interface SelectInputProps {
  field: FormField;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  onFocus?: () => void;
  onBlur?: () => void;
  disabled?: boolean;
}

export const SelectInput: React.FC<SelectInputProps> = ({
  field,
  value,
  onChange,
  error,
  onFocus,
  onBlur,
  disabled = false
}) => {
  const baseClasses = "w-full bg-elevated border border-subtle rounded-lg px-4 py-3 text-th-primary focus:border-brand focus:outline-none transition-all";
  const errorClasses = error ? "border-status-error focus:border-status-error" : "";

  return (
    <select
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      onFocus={onFocus}
      onBlur={onBlur}
      required={field.required}
      disabled={disabled}
      className={`${baseClasses} ${errorClasses}`}
    >
      <option value="">Select an option...</option>
      {field.options?.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};